module.exports = __webpack_public_path__ + "static/guidedao-meta-0635205621f0ef30507d6f076fa89adf.png";